import z from 'zod';
export const PUBLIC_HOLIDAY_KIND_FIXED = 'fixed';
export const PUBLIC_HOLIDAY_KIND_MOBILE = 'mobile';
export const PUBLIC_HOLIDAY_KINDS = [
    PUBLIC_HOLIDAY_KIND_FIXED,
    PUBLIC_HOLIDAY_KIND_MOBILE,
];
export const publicHolidayKindValue = z.enum(PUBLIC_HOLIDAY_KINDS);
//# sourceMappingURL=public-holiday-kind.js.map